import { Outlet } from "react-router-dom";
import MobileHeader from "@/components/MobileHeader";
import BottomNav from "@/components/BottomNav";
import { useAppForegroundRefresh } from "@/hooks/useAppForegroundRefresh";

const AppLayout = () => {
  useAppForegroundRefresh();
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <MobileHeader />
      {/* The pages handle their own <main> and headings to keep SEO semantics correct */}
      <div className="pb-20 mx-auto w-full max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl px-5 md:px-10 lg:px-24 xl:px-32 2xl:px-48 overflow-x-hidden">{/* space for bottom nav */}
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
};

export default AppLayout;
